import Copy from '../../src/legacy/Copy.tsx';
export default Copy;
